export const smallDeviceWidth = 450
export const mediumDeviceWidth = 810

export const widgetShadowSize = {
  height: 20,
  width: 30,
}

export const widgetOffset = {
  default: {
    bottom: 20,
    right: 20,
    left: 20,
  },
  smallDevice: {
    right: 20,
    bottom: 30,
  },
  mediumDevice: {
    bottom: 30,
    right: 40,
  },
}

export const widgetBaseSizes = {
  withAvatar: {
    default: '100%',
    smallDevice: 353,
    mediumDevice: 353,
  },
  classic: {
    default: '100%',
    smallDevice: 320,
    mediumDevice: 320,
  },
}

export const widgetSizes = {
  withAvatar: {
    default: {
      width: widgetBaseSizes.withAvatar.default,
    },
    smallDevice: {
      width:
        widgetBaseSizes.withAvatar.smallDevice +
        widgetOffset.smallDevice.right +
        widgetShadowSize.width,
    },
    mediumDevice: {
      width:
        widgetBaseSizes.withAvatar.mediumDevice +
        widgetOffset.mediumDevice.right +
        widgetShadowSize.width,
    },
  },
  classic: {
    default: {
      width: widgetBaseSizes.classic.default,
    },
    smallDevice: {
      width:
        widgetBaseSizes.classic.smallDevice +
        widgetOffset.smallDevice.right +
        widgetShadowSize.width,
    },
    mediumDevice: {
      width:
        widgetBaseSizes.classic.mediumDevice +
        widgetOffset.mediumDevice.right +
        widgetShadowSize.width,
    },
  },
}
